import React from "react";
import "./AboutMethod.css";

import chartSix from "../../images/Chart 6.webp";

const methodSteps = [
  {
    id: "learn",
    number: "01",
    label: "Learn",
    title: "Understand the setup",
    text: "Know what you are looking for before you risk capital.",
  },
  {
    id: "practice",
    number: "02",
    label: "Practise",
    title: "Apply the process",
    text: "Work through entries, exits and risk on real examples.",
  },
  {
    id: "review",
    number: "03",
    label: "Review",
    title: "Improve the decision",
    text: "Use feedback to trade with more discipline.",
  },
];

function AboutMethod() {
  return (
    <section
      id="trpc-about-method"
      className="trpc-aboutMethod"
      aria-labelledby="trpc-aboutMethod-title"
    >
      <div className="trpc-aboutMethod-frame">
        <div className="trpc-aboutMethod-chartLayer" aria-hidden="true">
          <img
            className="trpc-aboutMethod-chart"
            src={chartSix}
            alt=""
            loading="lazy"
            decoding="async"
          />
        </div>

        <div className="trpc-aboutMethod-copy">
          <span className="trpc-aboutMethod-kicker">Our Method</span>

          <h2 id="trpc-aboutMethod-title" className="trpc-aboutMethod-title">
            Learn. Practise. Review.
          </h2>

          <p className="trpc-aboutMethod-text">
            Every programme follows a simple loop: learn the concept, apply it
            to the market, then review the decision.
          </p>
        </div>

        <div className="trpc-aboutMethod-steps">
          {methodSteps.map((step) => (
            <article key={step.id} className="trpc-aboutMethod-step">
              <div className="trpc-aboutMethod-stepHeader">
                <span className="trpc-aboutMethod-number">{step.number}</span>
                <span className="trpc-aboutMethod-label">{step.label}</span>
              </div>

              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AboutMethod;